import { Component, inject } from '@angular/core';
import { EdiOrderResponseListConfigService } from '../../../services/edi-order-response-list-config/edi-order-response-list-config.service';

@Component({
    selector: 'lib-edi-order-response',
    template: `<lib-edi-list-wrapper
      [configService]="configService"
      title="Manage order responses">
    </lib-edi-list-wrapper>`,
    styles: [],
    standalone: false
})
export class EdiOrderResponseComponent {
  public configService = inject(EdiOrderResponseListConfigService);
}
